export default function IconCalendar({ size = 24 }: { size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M9 3v1H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4V3h-2v1H11V3zm10 6v10H5V9zM7 11v2h2v-2zm4 0v2h2v-2zm4 0v2h2v-2z"
      />
    </svg>
  );
}
